import { render, staticRenderFns } from "./GyHeader.vue?vue&type=template&id=3de96662&"
import script from "./GyHeader.vue?vue&type=script&lang=js&"
export * from "./GyHeader.vue?vue&type=script&lang=js&"
import style0 from "./GyHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports